import Svg from "../../utils/svg"
import styles from "./ReviewsList.module.scss"

interface Review {
  userName: string
  content: string
}

interface Props {
  className?: string
}

const ReviewsList = ({ className }: Props) => {
  const reviews: Review[] = [
    {
      userName: "Big bo toejoe",
      content:
        "Had the app for quite a long time now. Really pleased with it. so easy to use. ",
    },
    {
      userName: "StephInfectiion",
      content: "This app is fantastic, I have had it for over 10 years now!",
    },
    {
      userName: "Tim Stauffer",
      content:
        "The price is more than worth it for the value I’ve gotten out of this app.",
    },
  ]

  return (
    <div className={`${styles.container} ${className}`}>
      {reviews.map((review, index) => (
        <ReviewItem key={index} review={review} />
      ))}
    </div>
  )
}

const ReviewItem = ({ review }: { review: Review }) => {
  return (
    <div className={styles.reviewItem}>
      <div className={styles.reviewTopContainer}>
        <div className={styles.userName}>{review.userName}</div>
        <StarsView />
      </div>
      <div className={styles.content}>{review.content}</div>
    </div>
  )
}

const StarsView = () => {
  const stars = new Array(5).fill(0)

  return (
    <div className={styles.starsView}>
      {stars.map((_, index) => (
        <Svg.StarReview key={index} />
      ))}
    </div>
  )
}

export default ReviewsList
